module.exports = "<svg width=\"14\" height=\"11\" viewBox=\"-1 -1 14 11\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.046 4.252H.454M7.701 0l4.334 4.334-4.334 4.334\" stroke=\"#FFF\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrowRight.svg
// module id = 541
// module chunks = 0